import { UsersThree } from "@phosphor-icons/react";
import { PickerItemProps } from "../../types";

interface SupplierData {
  id: string;
  name: string;
  email?: string;
  tags?: string[];
}

export const SupplierItem = ({ item, isSelected, onSelect }: PickerItemProps<SupplierData>) => {
  return (
    <button
      onClick={() => onSelect(item)}
      className={`w-full text-left px-4 py-3 rounded-lg text-sm transition-all duration-200 border ${
        isSelected 
          ? "bg-moss-primary/10 border-moss-primary/40 ring-2 ring-moss-primary/20 shadow-sm" 
          : "border-neutral-primary/10 hover:border-neutral-primary/20 hover:bg-neutral-primary/5 hover:shadow-sm"
      }`}
    >
      <div className="flex items-center gap-3">
        <div className="shrink-0 w-8 h-8 rounded-lg bg-neutral-primary/5 flex items-center justify-center">
          <UsersThree className="h-4 w-4 text-neutral-primary/70" weight="duotone" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-semibold text-neutral-primary truncate">{item.name}</div>
          {item.email && (
            <div className="text-xs text-neutral-secondary-mid truncate mt-0.5">{item.email}</div>
          )}
          {item.tags && item.tags.length > 0 && (
            <div className="flex gap-1 mt-1.5 flex-wrap">
              {item.tags.slice(0, 2).map((tag, i) => (
                <span key={i} className="text-[10px] px-1.5 py-0.5 rounded-sm bg-neutral-primary/5 text-neutral-secondary-mid">
                  {tag}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>
    </button>
  );
};

interface FrequentSupplierData {
  supplier: SupplierData;
  ticketCount: number;
}

interface FrequentSupplierItemProps {
  item: FrequentSupplierData;
  isSelected: boolean;
  onSelect: (supplier: SupplierData) => void;
}

export const FrequentSupplierItem = ({ item, isSelected, onSelect }: FrequentSupplierItemProps) => {
  const handleSelect = () => onSelect(item.supplier);

  return (
    <button
      onClick={handleSelect}
      className={`w-full text-left px-4 py-3 rounded-lg text-sm transition-all duration-200 border shadow-sm ${
        isSelected 
          ? "bg-moss-primary/15 border-moss-primary/50 ring-2 ring-moss-primary/30 shadow-md" 
          : "bg-moss-primary/5 border-moss-primary/25 hover:bg-moss-primary/10 hover:border-moss-primary/40 hover:shadow-md"
      }`}
    >
      <div className="flex items-center gap-3">
        <div className="shrink-0 w-8 h-8 rounded-lg bg-moss-primary/20 flex items-center justify-center">
          <UsersThree className="h-4 w-4 text-moss-primary" weight="duotone" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-0.5">
            <span className="font-semibold text-neutral-primary truncate flex-1">{item.supplier.name}</span>
            <span className="text-[10px] font-bold bg-moss-primary text-white px-2 py-0.5 rounded-full shrink-0">
              {item.ticketCount}x
            </span>
          </div>
          {item.supplier.email && (
            <div className="text-xs text-neutral-secondary-mid truncate">{item.supplier.email}</div>
          )}
        </div>
      </div>
    </button>
  );
};